<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
      <vx-card>
        <div class="vx-row no-gutter mb-2">
          <div class="vx-col w-full">
            <span class="h5 float-left mt-2 mr-1">{{ group.division_name }}</span>
            <vs-button class="float-left" type="line" size="small" @click="showGroupLocalizationsDialog = true" color="primary" icon="edit" >Name/Localizations</vs-button>
            <vs-button class="float-right mx-2" type="gradient" size="small" @click="confirmDeleteGroup(group)" color="danger" icon="delete" ></vs-button>
          </div>
        </div>

        <div class="vx-row no-gutter">
          <div class="vx-col w-full">
            <label for="foobar">{{ `${group.products.length} Products` }}</label>
            <v-select id="foobar" multiple label="name" :value="selectedProducts" :reduce="product => product.product_id" @input="productSelectionChanged" :options="unSelectedProducts" />
          </div>
        </div>


        <vs-prompt
          buttons-hidden
          title="Edit Group Name"
          :active.sync="showGroupLocalizationsDialog">
          <div>

            <CompanyGroupLocalizationsCard :group="group"
                                           v-on:groupUpdated="onGroupLocalizationUpdate"
            ></CompanyGroupLocalizationsCard>
          </div>
        </vs-prompt>

      </vx-card>

</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';
  import CompanyGroupLocalizationsCard from './CompanyGroupLocalizationsCard';

  export default {
    components: {
      CompanyGroupLocalizationsCard,
    },
    data() {
      return {
        loadingCount: 0,
        types: types,
        jsonHtml: jsonHtml,
        showGroupLocalizationsDialog: false,
        helpers: productHelpers,
        selectedProductIds: [],
        allProducts: [],
      }
    },
    props: {
      group: {
        type: types.CompanyGroup(),
        required: true,
        default: () => {
          return new types.CompanyGroup()
        }
      },
      products: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },
    },
    mounted() {
      // window.addEventListener("keyup", function(e) {
      //   if (e.key === 'Escape') {
      //   }
      // });
    },
    watch: {
      group(oldVal, newVal) {
        if (newVal.id === oldVal.id) return;
        this.setUpWorkingData();
      },
      products(oldVal, newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.setUpWorkingData();
      },
    },
    computed: {
      selectedProducts() {
        return this.allProducts.filter((prod) => {
          return this.selectedProductIds.indexOf(prod.product_id) !== -1;
        });
      },
      unSelectedProducts() {
        return this.allProducts.filter((prod) => {
          return this.selectedProductIds.indexOf(prod.product_id) === -1;
        });
      },
    },
    methods: {
      onGroupLocalizationUpdate(updatedGroup) {
        console.log('group updated received @ ProductSelectionCard');
        this.$emit('groupUpdated', updatedGroup);
        this.showGroupLocalizationsDialog = false;
      },
      async productSelectionChanged(newSelectedProducts) {
        if (newSelectedProducts.length === this.selectedProductIds.length) return;
        const productAdded = newSelectedProducts.length > this.selectedProductIds.length;

        let success = false;
        if (productAdded) {
          let addedProductId = newSelectedProducts.filter(x => !this.selectedProductIds.includes(x))[0];
          console.log(`product ${addedProductId} added`);
          success = await api.addProductToCompanyGroup(addedProductId, this.group);
        } else {
          let removedProductId = this.selectedProductIds.filter(x => !newSelectedProducts.includes(x))[0];
          console.log(`product ${removedProductId} removed`);
          success = await api.deleteProductFromCompanyGroup(removedProductId, this.group);
        }

        this.showNotification(success, productAdded ? `Product added to ${this.group.division_name}` : `Product removed from ${this.group.division_name}`);

        this.selectedProductIds = newSelectedProducts;

      },
      setUpWorkingData() {
        this.selectedProductIds = this.group.products.map((prod) => prod.product_id);
        this.allProducts = this.products.map((prod) => {
          prod.name = this.helpers.getPreferredName(prod);
          return prod;
        });
      },
      confirmDeleteGroup(group) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${group.division_name}`,
          text: `Are you sure you want to delete this group?`,
          accept: () => {
            this.deleteGroup(group);
          }
        })
      },
      async deleteGroup(group) {
        const success = api.deleteCompanyProductGroup(group);
        if (!success) {
          this.showNotification(false, 'error deleting group');
          return;
        }

        this.showNotification(true, `Group "${group.division_name}" Deleted`);

        this.$emit('groupDeleted', group);

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
